import { ControllerInterface } from "csi/action/Controller";
import NewController from "csi/action/NewController";
import declare from "dojo/_base/declare";

export = declare(NewController, {

	/**
	 * @override
	 * Because the type of New action doesn't match the type of the table view, need to change m_idAttrParent so that the node can be attached to the correct relationship
	 */
	constructor(params: Record<string, any>) {
		this.inherited(arguments);

		const controller = this as unknown as ControllerInterface;
		controller.m_idAttrParent = "Factories";
	},
});
